import React, { useState, useRef, useEffect } from 'react';
import { State, States } from 'sigt';
import { connect } from 'react-redux';
import { Table, Input, Button, Col, Typography, DatePicker, Divider } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import Form, { FormInstance } from 'antd/lib/form';
import { SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import moment, { Moment } from 'moment';
import Axios from 'axios';
const server = process.env.REACT_APP_SERVER_URL;

interface SM {
  id: number;
  id_registro_municipal?: number;
  id_tarifa_aseo: number;
  codigo: string;
  descripcion: string;
  tarifa: string;
  key?: number;
}

const MunicipalServicesChange: React.FC<MunicipalServicesChangeProps> = ({ form, thm, data, preloaded }) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColum] = useState('');
  const [selected, setSelected] = useState<SM | null>(null);
  const searchInput = useRef<any>(null);
  const [loading, setLoading] = useState(false);
  const [rates, setRates] = useState<any[]>();

  useEffect(() => {
    if (preloaded) {
      if (preloaded.id_tarifas_aseo) {
        preloaded.id = preloaded.id_tarifas_aseo;
      }
      setSelected(preloaded);
    }
  }, [preloaded]);

  useEffect(() => {
    const fetchRates = async () => {
      setLoading(true);
      try {
        const response = await Axios.get(`${server}/CleaningFee/AllFee`);
        console.log(response.data);
        setRates(response.data.data.cleaningFee || []);
      } catch (e) {
        setRates([]);
      } finally {
        setLoading(false);
      }
    };
    fetchRates();
  }, []);

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder='Buscar'
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type='primary'
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size='small'
          style={{ width: 90, marginRight: 8 }}
        >
          Buscar
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size='small' style={{ width: 90 }}>
          Restablecer
        </Button>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? thm.primaryColor : undefined }} />,
    onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        if (searchInput.current) {
          searchInput.current?.select();
        }
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#1e72c675', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColum(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const columns: ColumnsType<any> = [
    {
      title: 'Código',
      dataIndex: 'id_tarifas_aseo',
    },
    {
      title: 'Nombre del Aforo',
      dataIndex: 'descripcion',
      ...getColumnSearchProps('descripcion'),
    },
  ];

  useEffect(() => {
    console.log('selected: ', selected);
  }, [selected]);

  return (
    <>
      <Table
        loading={loading}
        columns={columns}
        dataSource={
          rates?.map((i, k) => {
            i.key = i.id_tarifas_aseo;
            return i;
          }) || []
        }
        rowSelection={{
          selectedRowKeys: [selected?.id || 0],
          onSelect: (record) => record.id === selected?.id,
          type: 'radio',
          hideDefaultSelections: true,
          onChange: (r, v) => {
            console.log('r: ', r);
            console.log('v: ', v);
            form.setFieldsValue({ servicioMunicipal: v[0] });
            setSelected({ ...v[0], id: v[0].id_tarifas_aseo });
          },
        }}
      />

      {selected && (
        <React.Fragment key={selected?.codigo}>
          <Divider style={{ marginLeft: -5 }} orientation='left'>
            <Typography.Text strong>{selected?.descripcion}&nbsp;</Typography.Text>
          </Divider>
          <Col xs={24} xl={6} style={{ marginLeft: 10 }}>
            <Form.Item
              name='desdeServicioMunicipal'
              label='Desde'
              rules={[{ required: true, message: 'Debe ingresar desde cuando se declara para dicha actividad económica' }]}
            >
              <DatePicker disabled={false} style={{ width: '100%' }} format='DD-MM-YYYY' placeholder='Desde' />
            </Form.Item>
          </Col>
        </React.Fragment>
      )}
    </>
  );
};

const mapStateToProps = (state: State) => ({ thm: state.thm });

export default connect(mapStateToProps)(MunicipalServicesChange);

interface MunicipalServicesChangeProps {
  // smActivities: SM[]
  form: FormInstance;
  thm: States.ThemeColors;
  data: any;
  preloaded?: any; //IPreloaded
}

// interface IPreloaded extends SM {
//   desde: string | Moment
// }
